/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SharedMobileMoreWaysToBrowse_internalBuyLinks$ref = any;
export type SharedMobileMoreWaysToBrowse_internalBuyLinks = ReadonlyArray<{
    readonly anchorText: string | null;
    readonly url: string | null;
    readonly " $refType": SharedMobileMoreWaysToBrowse_internalBuyLinks$ref;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedMobileMoreWaysToBrowse_internalBuyLinks",
  "type": "InternalBuyLinkType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "anchorText",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "url",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '7a04b744719dfb2ef49a59cd802e22ba';
export default node;
